/**
 * Module de l'ecran courant, deduit de la route.
 *
 * Le contexte vient de la route, pas d'un choix de l'utilisateur. Sur
 * /sinistres, on cherche du sinistre sans avoir a le dire.
 *
 * Le prefixe le plus long gagne. Sans ce tri, deux prefixes qui se
 * chevauchent se disputeraient la meme correspondance selon l'ordre de
 * declaration, et le resultat dependrait de l'ordre d'ecriture du fichier.
 *
 * Une route inconnue rend null, ce que le serveur lit comme tous les types.
 * Rendre une chaine vide ou un module invente ferait taire la recherche sur
 * les ecrans ajoutes plus tard, sans que rien ne le signale.
 *
 * Verifie contre src/App.js le 2026-09-25 : /pv et /finance de la premiere
 * table redigee n'existaient pas, les ecrans reels sont /pv-sinistres et
 * /encaissements, /paiements, /comptabilite, /lot-reglements.
 */
const PREFIXES = [
  ['/courriers', 'COURRIERS'],
  ['/sinistres', 'SINISTRES'],
  ['/sinistres-lies', 'SINISTRES'],
  ['/reclamations', 'RECLAMATIONS'],
  ['/pv-sinistres', 'PV'],
  ['/attestations', 'ATTESTATIONS'],
  ['/attestations-digitales', 'ATTESTATIONS'],
  ['/encaissements', 'FINANCE'],
  ['/paiements', 'FINANCE'],
  ['/comptabilite', 'FINANCE'],
  ['/lot-reglements', 'FINANCE'],
];

export function moduleDeRoute(chemin) {
  if (!chemin) return null;
  const trouve = [...PREFIXES]
    .sort((a, b) => b[0].length - a[0].length)
    .find(([prefixe]) => chemin === prefixe || chemin.startsWith(`${prefixe}/`));
  return trouve ? trouve[1] : null;
}
